import { RootState } from 'redux/types';
import { SignupState } from '.';

export const getSignupValues = (store: RootState): SignupState => store.signup;
